<template>
    <div :class="classes" :style="{ fontSize: fontSize }">
        <h1 v-if="heading === 1" :style="{ textAlign: title.alignment, color: title.colour }" v-show="title.show">
            {{ title.text }}
        </h1>

        <h2 v-else-if="heading === 2" :style="{ textAlign: title.alignment, color: title.colour }" v-show="title.show">
            {{ title.text }}
        </h2>

        <h3 v-else-if="heading === 3" :style="{ textAlign: title.alignment, color: title.colour }" v-show="title.show">
            {{ title.text }}
        </h3>

        <h4 v-else-if="heading === 4" :style="{ textAlign: title.alignment, color: title.colour }" v-show="title.show">
            {{ title.text }}
        </h4>

        <h5 v-else-if="heading === 5" :style="{ textAlign: title.alignment, color: title.colour }" v-show="title.show">
            {{ title.text }}
        </h5>

        <h6 v-else :style="{ textAlign: title.alignment, color: title.colour }" v-show="title.show">
            {{ title.text }}
        </h6>

        <widget-description v-if="title.description" :content="title.description"></widget-description>

        <section v-for="section in sections" class="object-section">
            <h4 class="section-title" :style="{ textAlign: retrieveAlignment(section), display: section.title.display }" v-show="section.title.show" v-html="section.title.text"></h4>
            <p class="section-content" :style="{ textAlign: retrieveAlignment(section), fontSize: retrieveFontSize(section) }" v-show="section.content.show" v-html="section.content.text"></p>
            <template v-if="section.table">
                <data-table
                    :title="retrieveTitle(section.table)"
                    :classes="retrieveClasses(section.table)"
                    :columns="section.table.columns"
                    :colspan="section.table.columns.headings.length"
                    :rows="section.table.rows"
                    :tables="section.table.tables"
                    :footer="section.table.footer"
                    :level="4"
                    :heading="4"
                />
            </template>
        </section>
    </div>
</template>

<script>
    import Widget from './Widget.vue';
    import WidgetDescription from "./WidgetDescription.vue";
    import DataTable from "./DataTable.vue";

    export default {
        extends: Widget,
        components: {DataTable, WidgetDescription},
        props: [
            'classes',
            'title',
            'sections',
            'fontSize',
            'level',
            'heading'
        ]
    }
</script>
